// Copyright (C) 2026 Skylark Drones

import BaseApi from './baseHttpApi'
import { BASE_API_HOST_URL } from '@/constants'

export default class OAuthApi extends BaseApi {
  whitelistURLs = []

  constructor() {
    super('oauth', BASE_API_HOST_URL)
    this.setPublicRequestInterceptors()
  }

  setPublicRequestInterceptors() {
    this.publicHttp.interceptors.request.use(config => {
      const idToken = localStorage.getItem('idToken')

      if (idToken && idToken !== 'null') {
        config.headers.Authorization = idToken
      }

      return config
    })
  }
}
